import { render, staticRenderFns } from "./CandidateAssignOffer.vue?vue&type=template&id=4fb54bf2"
import script from "./CandidateAssignOffer.vue?vue&type=script&lang=js"
export * from "./CandidateAssignOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports